// utilsArtefact.jsx
// Utility functions for Artefact operations

import { isNull } from "lodash";

// Add a new Artefact
export function addArtefact(dsd, Data, onAdd, onError) {
    let headers = {
        headers: {
            "Content-type": "application/json"
        }
    };

    let authHeader = dsd.authHeader();
    if (authHeader) {
        headers.headers.Authorization = authHeader.Authorization;
    }

    let payload = payloadArtefact(Data);

    dsd.httpConfig.post(`/artefacts`, payload, headers)
        .then(response => {
            if (onAdd) {
                onAdd(response.data.id);
            }
        })
        .catch(e => {
            if (onError) {
                onError(e);
            }
            console.log(e);
        });

    return;
}

// Edit an existing Artefact
export function editArtefact(dsd, id, Data, onUpdate, onError) {
    let headers = {
        headers: {
            "Content-type": "application/json"
        }
    };

    let authHeader = dsd.authHeader();
    if (authHeader) {
        headers.headers.Authorization = authHeader.Authorization;
    }

    let payload = payloadArtefact(Data);

    dsd.httpConfig.put(`/artefacts/${id}`, payload, headers)
        .then(response => {
            if (onUpdate) {
                onUpdate();
            }
        })
        .catch(e => {
            if (onError) {
                onError(e);
            }
            console.log(e);
        });

    return;
}

// Create payload for Artefact
export function payloadArtefact(data) {
    let payload = {};
    payload.name = data.name;
    payload.description = data.description;
    payload.proposals = data.proposals;
    payload.type = data.type;

    if (data.Resources) {
        payload.Resources = data.Resources;
    }

    payload.status = data.status;

    return payload;
}

// Process Artefact data
export function dataArtefact(data) {
    let Artefact = data;
    return Artefact;
}

// Get a single Artefact
export const getArtefact = (dsd, id=null, onLoad=null, onFail=null, representation="dsd", format=null, options={}) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();

    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let URL = `/artefacts/${id}?`

        if (representation){
        URL += `&representation=${representation}`;
    }

    if (format){
        URL += `&format=${format}`;
    }

    if (options) {
        for (const [key, value] of Object.entries(options)) {
            if (value === true) URL += `&${key}=true`;
            else if (value !== false && value != null) URL += `&${key}=${encodeURIComponent(value)}`;
        }
    }

    return(                
        dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (onLoad){
                onLoad(response.data);
            }
        })
        .catch(e => {
            if (onFail){
                onFail(e)
            }
        })
            
    );

    return;

};

// List Artefacts with optional filters
export function listArtefacts(dsd, Filters = {}, onLoad, onError) {
    let headers = {
        headers: {
            "Content-type": "application/json"
        }
    };

    let authHeader = dsd.authHeader();
    if (authHeader) {
        headers.headers.Authorization = authHeader.Authorization;
    }

    let urlAPI = "/artefacts";
    if (Object.keys(Filters).length > 0) {
        urlAPI += "?";
    }

    if (Filters.idUser) {
        urlAPI += `idUser=${encodeURIComponent(Filters.idUser)}&`;
    }

    if (Filters.status) {
        urlAPI += `status=${encodeURIComponent(Filters.status)}&`;
    }

    if (Filters.idProcess) {
        urlAPI += `idProcess=${encodeURIComponent(Filters.idProcess)}&`;
    }

    if (Filters.scope) {
        urlAPI += `scope=${encodeURIComponent(Filters.scope)}&`;
    }

    if (Filters.search) {
        urlAPI += `search=${encodeURIComponent(Filters.search)}&`;
    }

    dsd.httpConfig.get(urlAPI, headers)
        .then(response => {
            let arrArtefacts = [];
            for (let pos = 0; pos < response.data.length; pos++) {
                arrArtefacts.push(dataArtefact(response.data[pos]));
            }

            if (onLoad) {
                onLoad(arrArtefacts);
            }
        })
        .catch(e => {
            if (onError) {
                onError(e);
            }
            console.log(e);
        });

    return;
}
